<template>
  <el-row>
    <el-col :span="8">
      <h6 :class="total > maxEligibleAmount ? 'text-danger' : 'text-success'">
        Paid By Customer</h6>
    </el-col>
    <el-col :span="4" :offset="12" class="text-right"
            :class="total > maxEligibleAmount ? 'text-danger' : 'text-success'">
      {{ total | currency }}
    </el-col>
  </el-row>
</template>

<script>
import {currency} from '../../../../filters';

export default {
  name: 'OrderUpdatePaymentCustomer',
  filters: {
    currency,
  },
  props: {
    total: {
      type: Number,
      required: true,
    },
    maxEligibleAmount: {
      type: Number,
      required: true,
    },
  },
};
</script>
